var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrappingUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 503.14,
    height: 502.82,
    viewBox: "0 0 743.05 742.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        isolation: isolate;\n      }\n\n      .cls-14, .cls-17, .cls-2, .cls-25, .cls-26, .cls-6, .cls-7 {\n        fill: none;\n      }\n\n      .cls-2, .cls-25 {\n        stroke: #1c297d;\n      }\n\n      .cls-14, .cls-17, .cls-2, .cls-25, .cls-6, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        stroke-width: 2.28px;\n      }\n\n      .cls-3 {\n        fill: #aaaccf;\n      }\n\n      .cls-4 {\n        fill: #8288d4;\n        opacity: 0.21;\n        mix-blend-mode: multiply;\n      }\n\n      .cls-5 {\n        fill: #b8bae0;\n      }\n\n      .cls-26, .cls-6 {\n        stroke: #fffcfa;\n      }\n\n      .cls-6 {\n        stroke-width: 2px;\n      }\n\n      .cls-14, .cls-17, .cls-7 {\n        stroke: #fff;\n      }\n\n      .cls-7 {\n        stroke-width: 3.38px;\n      }\n\n      .cls-8 {\n        fill: #27427a;\n      }\n\n      .cls-9 {\n        fill: #4e62e0;\n      }\n\n      .cls-10 {\n        fill: #bbbcc9;\n      }\n\n      .cls-11 {\n        fill: #e0e0e0;\n      }\n\n      .cls-12, .cls-28 {\n        fill: #fffcfa;\n      }\n\n      .cls-13 {\n        fill: #ed5353;\n      }\n\n      .cls-14 {\n        stroke-width: 4.56px;\n      }\n\n      .cls-15 {\n        fill: #9b9ecf;\n      }\n\n      .cls-16 {\n        fill: #c3c5ed;\n      }\n\n      .cls-17 {\n        stroke-width: 3.58px;\n      }\n\n      .cls-18 {\n        fill: #1737a2;\n      }\n\n      .cls-19 {\n        fill: #3754b8;\n      }\n\n      .cls-20 {\n        fill: #e67c4e;\n      }\n\n      .cls-21 {\n        fill: #80653d;\n      }\n\n      .cls-22 {\n        fill: #ba4141;\n      }\n\n      .cls-23 {\n        fill: #34c8cc;\n      }\n\n      .cls-24 {\n        fill: #fff;\n      }\n\n      .cls-26 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-27 {\n        fill: #f2c97b;\n      }\n\n      .cls-28 {\n        opacity: 0.71;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "contract-agreement") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "image"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.82,447.73l1.85-23.56,5.53,1.74c6.09,1.91,11.16-1.92,11.27-8.52l1-60c.11-6.6-4.77-13.56-10.86-15.48L41.91,316.22c-6.08-1.91-11.15,1.92-11.27,8.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "436.23 692.65 500.6 694.99 581.45 676.62 581.45 623.95 444.29 650.07 436.23 692.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "587.49 675.53 743.05 560.51 502.93 483.3 587.49 675.53"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 306.16,
    cy: 731.4,
    rx: 20.95,
    ry: 11.17
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M242.91,253.21S107.74,214,137.49,10.2C137.49,10.2,318.63,103,242.91,253.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.46,311.73S54.37,321.74,0,35.11C0,35.11,285.39,75.61,253.46,311.73Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 217.29,
    y1: 267.54,
    x2: 35.64,
    y2: 76.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 79.41,
    y1: 123.74,
    x2: 31.81,
    y2: 116.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 123.1,
    y1: 166.39,
    x2: 54.32,
    y2: 165.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 82.06,
    y1: 70.77,
    x2: 79.41,
    y2: 123.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 129.83,
    y1: 96.87,
    x2: 123.1,
    y2: 166.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 175.93,
    y1: 143.45,
    x2: 169.2,
    y2: 212.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M90.29,213.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 166.1,
    y1: 215.48,
    x2: 97.32,
    y2: 214.24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M602.89,87,231.6.32a7.28,7.28,0,0,0-7.93,2.55h0l-20.55,16,17.77,43V535.66c0,8,4.82,16,10.71,17.69l324.06,93.13,32,29,20.87-15.88-.09-.15c3.09-1.69,5.17-5.72,5.17-11V104.68C613.61,96.65,608.79,88.68,602.89,87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M581.45,676.62,211.23,577.5c-5.88-1.58-10.69-9.44-10.69-17.48V27.63c0-8,4.81-13.33,10.69-11.75l370.22,87.67c5.88,1.58,10.69,9.44,10.69,17.48V664.86C592.13,672.9,587.33,678.19,581.45,676.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "571.55 638.52 229.72 547 229.72 57.72 571.55 138.27 571.55 638.52"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M559.17,144.91l-357.11-78C260,399.2,180.51,606,180.51,606l320.08,89C585,446.8,559.17,144.91,559.17,144.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M559.17,144.91,194.65,57.29c21.13,326.29-130,529.77-130,529.77L436.22,692.65C584.59,476.71,559.17,144.91,559.17,144.91Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 398.42,
    y1: 244.41,
    x2: 496.94,
    y2: 270.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 389.2,
    y1: 314.72,
    x2: 487.72,
    y2: 340.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 239.88,
    y1: 349.81,
    x2: 457.5,
    y2: 406.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 204.74,
    y1: 423.67,
    x2: 422.36,
    y2: 480.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 293.41,
    cy: 258.86,
    rx: 50.24,
    ry: 59.18,
    transform: "translate(-94.93 211.01) rotate(-34.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M255,194c10.93-6.12,24.17-8.6,38.43-6.31,37.49,6,67.88,42.76,67.88,82.06S330.9,336,293.41,330,225.54,287.25,225.54,248c0-18.6,6.8-34.43,17.94-45.32"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-14",
    points: "269.56 246.05 286.5 279.26 317.26 238.47"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M457.2,93.41l-3.2-.78c-2.57-16.09-14.48-30.86-28.38-34.22L333.57,36.2c-13.9-3.35-25.22,5.82-27,20.86l-3.21-.77c-15.43-3.73-27.69,8-27.25,26h0c.45,18,13.45,35.86,28.88,39.58L458.83,159c15.44,3.73,27.7-8,27.25-26h0C485.63,114.94,472.64,97.13,457.2,93.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M447.29,101.6l-3.21-.78C441.52,84.74,429.6,70,415.7,66.6L323.65,44.39c-13.9-3.35-25.22,5.82-27,20.86l-3.2-.77c-15.44-3.73-27.7,8-27.25,26h0c.45,18,13.44,35.86,28.88,39.58l153.85,37.12c15.43,3.73,27.69-8,27.25-26h0C475.72,123.13,462.72,105.32,447.29,101.6Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 304.41,
    y1: 80.17,
    x2: 434.14,
    y2: 113.78
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 169.6,
    y1: 497.54,
    x2: 387.22,
    y2: 554.57
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M429.45,598h0a6.16,6.16,0,0,1-2.79-7.76l49.66-108.87A30,30,0,0,0,477.74,460a32,32,0,0,0-15.06-18.46l-35.62-19.6,4.54-10,34.55,19a46.7,46.7,0,0,1,21.15,23.65c4.1,10.62,3.92,21.87-.49,31.54l-50,109.69A5.13,5.13,0,0,1,429.45,598Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M419.52,405.8,308.91,679.43c-5.06,11.84-3.76,22.25,9.12,26.51h0c12.73,4.22,21.16-1.38,26.16-13.08L465,423.32C475,402.56,429.5,385,419.52,405.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M458.85,404.29c-10.5-2.87-22-1.25-26.48,8L321.76,685.94c-3.57,8.35-3.95,16,.62,21.24A28.74,28.74,0,0,1,318,706.1c-12.88-4.27-14.18-14.68-9.12-26.52L419.52,406C426,392.5,447.33,395.13,458.85,404.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M343.06,695.28s-7,12.27-24.67,29.07c-3.33,3.16-14.58-1.37-14.71-5.71-.33-11-.48-21.49,2.75-30.89C316.08,702.44,328.62,703.38,343.06,695.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M318.39,724.35,313.33,728l-5.66,4.05a1.71,1.71,0,0,1-2.73-1l-.74-6.33-.6-7C306.29,724.49,311.87,726.05,318.39,724.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M465.27,399.71l-.07.16h0l-6.91,17c-1.93,4.73-10,6.2-18,3.29s-12.94-9.13-11-13.86l6.91-17h0l.06-.17c1.93-4.73,10-6.21,18-3.29S467.2,395,465.27,399.71Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M136.15,478.45l-25.53,32.3a13.34,13.34,0,0,0-2,13l16.47,43.84,9.86-9.4-.76-39.72Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 161.6,
    cy: 722.12,
    rx: 37.51,
    ry: 16.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M134.67,703.91l8.5,1c5.6-1.93,8.18-3.86,10.8-1.08l.74.78c1.2,2,.88,5.53-1,7L140,723.2c-2.86,1.51-8.29.38-9.29-3.79,0,0-1-11.72.36-12.36C133.71,705.75,132.39,705.11,134.67,703.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M142.89,711.2c-.06,4.49-11,4.36-10.93-.13l.18-14.61,10.92.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M146.7,697.86c-4.16,5.1-13.6,5-15.4,1.57.22-20.34-5.23-42,4.63-70l-3.37-84.82,37.85,7.54-14.68,89.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M170.79,717.83l11,1.84c8.07-1.09,12.11-2.52,14.73.26l.74.79c1,1.93-.56,5-3.52,6.18l-21.94,8.76c-4.29,1-8.79-.46-8.81-4.3,0,0,0-10.72,2-11.14C168.92,719.37,167.36,718.64,170.79,717.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M176.51,723.07c0,4.49-11,4.36-10.93-.13l.18-14.6,10.93.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M179,710c-3.82,5.17-13.29,5.08-15.33,1.58-1.19-20.65-8.16-42.65-.19-71.05l-9.24-86.14,38.5,7.69L184.18,653Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M178.5,456.3c.19,8.85-7.61,14.49-14.37,10.78s-12.41-13.91-12.6-22.75,5.15-13,11.91-9.3S178.31,447.45,178.5,456.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M158.69,484.55l-.91-.19a5.76,5.76,0,0,1-4.46-6.78l3.6-17.42a5.76,5.76,0,0,1,6.78-4.46l.92.19a5.76,5.76,0,0,1,4.46,6.78l-1,17.25C167.43,483,161.78,485.19,158.69,484.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M148.72,465.58s1.94,5.88,12.73,4.12c8.15-1.32,1.58-15.08,8.9-18.93,9.91-5.2,5.42-14.92.78-17.94S160.88,432,154,434.65C146.69,437.5,136.87,443.74,148.72,465.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M170.08,455.39a3.9,3.9,0,1,1-4-3.81A3.9,3.9,0,0,1,170.08,455.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M168.31,468.81l-1.52-1.76a5.87,5.87,0,0,0,4.93-.23A7.47,7.47,0,0,1,168.31,468.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M167.73,458.07h0a1.3,1.3,0,0,1-1.51-1.05l-2.71-8.14c-.13-.7,1.74-.37,2.44-.5h0c.7-.13,2.69-.88,2.82-.17v8.34A1.31,1.31,0,0,1,167.73,458.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 174.59,
    y: 461.37,
    width: 13.05,
    height: 17.48,
    rx: 5.91,
    transform: "translate(652.84 647) rotate(131.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M189.53,471.91s18.31,30.43,18.13,48.67c-.1,11-13.93,4.15-13.93,4.15L180.51,478.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M168.41,505.69,188.14,533c4.27,9.24,30.75,0,20.31-17.06-.4-.65-21.69-31.23-21.69-31.23S168.68,492,168.41,505.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M130.94,503.72l-5.85,73.11s3.89,7.77,26.72,9.79a128.29,128.29,0,0,0,42.73-3.85v-68l-7.77-30.08s1.13-1-16.69-7.57l-20.72-4.65s-11.22.1-13.2,5.94S130.94,503.72,130.94,503.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M149.35,472.51s-1.65,5.29,4.57,6.92,16.15-2.27,16.15-2.27S163,470.44,149.35,472.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M137.84,476,112,505.49a6.15,6.15,0,0,0-.64,7.22c4.44,7.39,14.65,21.86,22.24,13.45C143.57,515.11,137.84,476,137.84,476Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 128.94,
    y1: 528.68,
    x2: 129.99,
    y2: 498.61
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-25",
    points: "192.73 534.87 175.37 510.7 172.22 508.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M159.82,614.11,155.42,596s-6.26.53-10.49-2.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M426.17,400.67s-3.56,18.79,22.24,21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M343.06,695.28s-24.08,14.41-36.63-7.53"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 379.65,
    cy: 44.54,
    rx: 20.89,
    ry: 25.72,
    transform: "translate(139.01 341.54) rotate(-57.68)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 371.18,
    cy: 54.35,
    rx: 20.89,
    ry: 25.72,
    transform: "translate(126.78 338.95) rotate(-57.68)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "558.62 380.95 606.65 394.19 599.59 431.95 541.92 415.97 548.12 378.32 558.62 380.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "565.58 443.43 613.61 456.66 606.55 494.43 548.88 478.44 553.45 440.38 565.58 443.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M95.9,356,14.17,330.29C8.09,328.38,3,332.21,2.9,338.81l-1,60c-.11,6.6,4.78,13.56,10.86,15.47L64.64,430.6l22.44,31.21,1.85-23.57L94.46,440c6.09,1.91,11.16-1.92,11.27-8.52l1-60C106.87,364.86,102,357.9,95.9,356Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.39,375.68c.34,4.14-2.46,7.5-6.26,7.5s-7.16-3.36-7.5-7.5,2.46-7.5,6.26-7.5S32.05,371.54,32.39,375.68Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 51.45,
    cy: 383.26,
    rx: 6.76,
    ry: 7.63,
    transform: "translate(-150.08 53.23) rotate(-23.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83.75,392.44c.34,4.14-2.47,7.5-6.27,7.5s-7.16-3.36-7.5-7.5,2.46-7.5,6.27-7.5S83.4,388.3,83.75,392.44Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-26",
    x1: 588.65,
    y1: 105.81,
    x2: 607.71,
    y2: 94.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrappingUp);
export default __webpack_public_path__ + "static/media/WrappingUp.2ccc825ea6336d224ae554f8877a5e4e.svg";
export { ForwardRef as ReactComponent };